module.exports = __webpack_public_path__ + "static/media/pin_user_location.23b4eaea.png";